module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_train_color_orange-b82e247ba5aa1fd1d907fd8d59bbe6ba.svg";